import localStorage from './localStorage'
import toast from './toast'

function parseResponse(response) {
    if(!response) return null
    try {
        return JSON.parse(response)
    } catch (error) {
        return response
    }
}

export default function(method, path, data, auth, displayError = true) {
    return new Promise(async function(resolve, reject) {
        let xhr = new XMLHttpRequest();
        let lang = window.localStorage.getItem('lang');
        xhr.open(method, `${process.env.VUE_APP_API_URL}${path}`)
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.setRequestHeader('Accept-Language', lang || 'es_MX');
        xhr.timeout = 5000;

        if(auth) {
            let user = localStorage.get('session');
            if(user && user.token) xhr.setRequestHeader('Authorization', `${user.token}`);
        }

        xhr.onload = function() {
            if(this.status >= 200 && this.status <= 300) {

                resolve({
                    status: this.status,
                    data: parseResponse(this.response),
                    count: this.getResponseHeader('Count')? Number(this.getResponseHeader('Count')) : null
                });
                return false;
            }

            if(this.status === 401) localStorage.remove('session')
            if(displayError) toast.error(this.response);
            reject({status: this.status, response: parseResponse(this.response)})
        };

        xhr.onerror = function(error) {
            console.log(error)
            if(displayError) toast.error('Algo salió mal, intentalo más tarde');
            reject(error)
        };

        xhr.ontimeout = function (event) {
            if(displayError) toast.error('El servidor tardo demasiado en responder');
            reject(event)
        };

        xhr.send(JSON.stringify(data))
    });
}